export const ACTIVIDAD_RESERVA_DETALLE_GET = 'ARD_GET'

export const ACTIVIDAD_RESERVA_DETALLE_SET_DATA = 'ARD_SET_DATA'

export const ACTIVIDAD_RESERVA_DETALLE_CLEAR = 'ARD_CLEAR'

export const ACTIVIDAD_RESERVA_DETALLE_LOADING = 'ARD_LOADING'
